import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core'
import {ProductScope, TranslationService, WindowRef} from '@spartacus/core'
import {CurrentProductService} from '@spartacus/storefront'
import {map} from 'rxjs/operators'
import {classificationCodes} from '../../../shared/mb-constants'

@Component({
  selector: 'mb-pdp-header-info',
  templateUrl: './pdp-header-info.component.html',
  styleUrls: ['./pdp-header-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PdpHeaderInfoComponent {

  constants = classificationCodes
  state$ = this.currentProductService.getProduct([ProductScope.ATTRIBUTES, ProductScope.DETAILS]).pipe(
    map(product => {
      return {
        product,
        alternativeNames: product?.classifications
          ?.find(classification => classification.code === this.constants.orderInformation)?.features
          ?.find(feature => feature.code === this.constants.orderInformationAlternativeNames)?.featureValues
          ?.map(featureValue => featureValue.value),
        recombinant: product?.classifications
          ?.find(classification => classification.code === this.constants.stamps)?.features
          ?.find(feature => feature.code === this.constants.stampRecombinantCode)?.featureValues
          ?.map(featureValue => featureValue.value),
        validation: product?.classifications
          ?.find(classification => classification.code === this.constants.stamps)?.features
          ?.find(feature => feature.code === this.constants.stampExtendedValidationCode)?.featureValues
          ?.map(featureValue => featureValue.value),
      }
    }))

  constructor (protected currentProductService: CurrentProductService,
              protected translationService: TranslationService,
              protected winRef: WindowRef) {
  }

  showReviews () {
    this.translationService
      .translate('mbproduct.reviews')
      .subscribe((reviewsTabLabel: string) => {
        const reviewsTab = this.getTabByLabel(reviewsTabLabel, this.getTabsComponent())
        const reviewsComponent = this.getReviewsComponent()
        const navigationButton = this.winRef.document.querySelector('nav[data-cy="navigation"]') as HTMLElement
        if (reviewsTab && reviewsComponent) {
          this.clickTabIfInactive(reviewsTab)
          this.winRef.nativeWindow?.setTimeout(
            () =>
              this.winRef.nativeWindow?.scroll({
                top: reviewsTab.offsetTop - (navigationButton.offsetHeight + reviewsTab.offsetHeight),
                behavior: 'smooth'
              }), 0
          )
        }
      }).unsubscribe()
  }

  private getReviewsComponent (): Element | null {
    return this.winRef.document.querySelector('mb-pdp-reviews-tab')
  }

  private getTabsComponent (): Element | null {
    return this.winRef.document.querySelector('mb-pdp-tabs')
  }

  private clickTabIfInactive (tab: HTMLElement): void {
    if (!tab.classList.contains('active') || tab.classList.contains('toggled')) {
      tab.click()
    }
  }

  private getTabByLabel (label: string, tabsComponent: Element | null) {
    if (tabsComponent) {
      const tabElements: HTMLCollectionOf<HTMLElement> = tabsComponent.getElementsByTagName(
        'button'
      )
      // Look through button tab elements until finding tab with label
      for (const buttonElement of Array.from(tabElements)) {
        if (buttonElement?.innerHTML?.includes(label)) {
          return buttonElement
        }
      }
    }
    return undefined
  }
}
